import { HTTP } from "./HttpServices";

const endpoint = "/deliveries";

const getDeliveries = query => {
  return HTTP.get(endpoint.concat(query).concat("&sort=createdAt,desc")).then(resp => resp);
};

const getPetDeliveries = (petId) => {
  let url = "/deliveryproducts" + "/pets/" + petId;
  return HTTP.get(url).then(resp => resp);
};

const getDeliveriesByQuery = (query) => {
  let url =
    "/deliveryproducts/report" +
    query;
  return HTTP.get(url).then(resp => resp);
};

const create = () => {
  return HTTP.get(endpoint + "/generate");
};

const update = delivery => {
  return HTTP.put(endpoint.concat("/").concat(delivery.id), delivery);
};

const remove = deliveryId => {
  return HTTP.delete(endpoint.concat("/").concat(deliveryId));
};

export default {
  getDeliveries,
  create,
  update,
  remove,
  getPetDeliveries,
  getDeliveriesByQuery
};
